import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {graphql, StaticQuery} from 'gatsby'

import WavyBackground from '../../../components/WavyBackground'
import RecentNews from '../../../components/RecentNews'
import Button from '../../../components/Button'
import WidthContainer from '../../../components/WidthContainer'


const RootContainer = styled(WavyBackground)`
	margin-top: 4.62rem;
`
RootContainer.defaultProps = {
	type: 'grayTop',
}

const InnerContainer = styled(WidthContainer)`
`

const Title = styled.h2`
	margin-bottom: 3rem;
`

const MoreButtonContainer = styled.div`
	margin-top: 4rem;
	display: flex;
	justify-content: center;

`
const MoreNewsSection = ({className, currentSlug}) => <StaticQuery
	query={graphql`
	{
		newsPage: file(relativePath: {eq: "pages/newsPage.json"}) {
			childPagesJson {
				url
			}
		}
	}
`}
	render={(data) => {
		const {url: newsPageUrl} = data.newsPage.childPagesJson
		return <RootContainer className={className}>
			<InnerContainer>
				{/* TODO move intro translations */}
				<Title>More news</Title>
				<RecentNews excludeArticleSlug={currentSlug}/>
				<MoreButtonContainer>
					<Button to={newsPageUrl}>More news</Button>
				</MoreButtonContainer>
			</InnerContainer>
		</RootContainer>
	}}/>

MoreNewsSection.propTypes = {
	className: PropTypes.string,
	currentSlug: PropTypes.string.isRequired,
}

MoreNewsSection.defaultProps = {
	className: '',
}

export default MoreNewsSection
